import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {IABTestingState} from "../types/IABTestingState";
import {ABTestDataLayerQueue} from "../utils/ab_test_data_layer_queue";
import {EXCLUDED_VARIANT} from "../utils/get_ab_test_variant_from_query";
import {useABTestVariant} from "./use_eperiment_variant";

export interface IProps {
    disableEventPush?: boolean;
    pushEventOnlyOnce?: true;
    id: string;
    variants: string[];
    withSSR?: boolean;
}

export const useABTest = (props: IProps) => {
    const [isClient, setIsClient] = useState<boolean>(false);

    const variant = useABTestVariant(props.id);

    const isInitialized = useSelector((state: IABTestingState) => state.abTesting.isInitialized);

    useEffect(() => {
        const isVariantValid = typeof variant === "string" && variant.length > 0;
        const isTestGroup = isVariantValid && variant !== EXCLUDED_VARIANT;

        if (!props.disableEventPush && isVariantValid && isTestGroup) {
            useABTest.dataLayerQueue.pushEvent({id: props.id, variant, pushOnlyOnce: props.pushEventOnlyOnce});
        }

        /*
         * If variant is not valid and ABTesting instance was initialized that means that variant for AB test was not generated.
         * The reason may be wrong `paths` configuration for AB Test. In such cases we need to render default component.
         */
        if ((!props.withSSR && !isClient && isVariantValid) || (!isVariantValid && !isClient && isInitialized)) {
            setIsClient(true);
        }
    }, [variant]);

    return {
        canABTestBeRendered: props.withSSR || isClient,
        abTestVariant: variant
    };
};

useABTest.dataLayerQueue = ABTestDataLayerQueue();
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {IABTestingState} from "../types/IABTestingState";
import {ABTestDataLayerQueue} from "../utils/ab_test_data_layer_queue";
import {EXCLUDED_VARIANT} from "../utils/get_ab_test_variant_from_query";
import {useABTestVariant} from "./use_eperiment_variant";

export interface IProps {
    disableEventPush?: boolean;
    pushEventOnlyOnce?: true;
    id: string;
    variants: string[];
    withSSR?: boolean;
}

export const useABTest = (props: IProps) => {
    const [isClient, setIsClient] = useState<boolean>(false);

    const variant = useABTestVariant(props.id);

    const isInitialized = useSelector((state: IABTestingState) => state.abTesting.isInitialized);

    useEffect(() => {
        const isVariantValid = typeof variant === "string" && variant.length > 0;
        const isTestGroup = isVariantValid && variant !== EXCLUDED_VARIANT;

        if (!props.disableEventPush && isVariantValid && isTestGroup) {
            useABTest.dataLayerQueue.pushEvent({id: props.id, variant, pushOnlyOnce: props.pushEventOnlyOnce});
        }

        /*
         * If variant is not valid and ABTesting instance was initialized that means that variant for AB test was not generated.
         * The reason may be wrong `paths` configuration for AB Test. In such cases we need to render default component.
         */
        if ((!props.withSSR && !isClient && isVariantValid) || (!isVariantValid && !isClient && isInitialized)) {
            setIsClient(true);
        }
    }, [variant]);

    return {
        canABTestBeRendered: props.withSSR || isClient,
        abTestVariant: variant
    };
};

useABTest.dataLayerQueue = ABTestDataLayerQueue();
